import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import MultiLineData from '../../../../components/Display/MultiLineData';

function PillsItem({ pills, handleClickPills }) {
  return (
    <div
      className="flex flex-row items-center py-3 px-3 shadow-sm gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-fit mb-2"
      onClick={handleClickPills}>
      <div className="flex flex-col justify-around h-full w-full">
        <div className="flex flex-col gap-y-1 mb-3">
          <div className="text-xl font-bold text-slate-700 ">{pills.label}</div>
          <div className="flex flex-col gap-1">
            <MultiLineData key="description" value={pills.details} large asHtml />
          </div>
        </div>
        <div className="flex flex-row gap-x-3">
          <Tag
            tag={{
              label: getConstant('quatrebis.pillsType', pills.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PillsItem;
